import { generateFGLTicket, generateFGLFlexpass, generateFGLCoupon } from './templates';

export default class Boca {
    constructor() {
        this.state = {
            bocaPrinters: null,
            JSPM_WS_Status: null
        }
    };

    getJSPrintManager = () => {
        this.getJSPM();
    }
    getBocaPrinters = () => {
        // script 1
        return new Promise((resolve, reject) => {
            this.startPrinterOrRejectPromise(resolve, reject);
        });
    };

    jspmWsStatusChanged = (status) => {
        console.log("jspmWsStatusChanged:", status);
        this.state.JSPM_WS_Status = status;
    };

    jspmWsUpdateStatus = () => {
        this.jspmWsStatusChanged(
            window.JSPM.WSStatus[window.JSPM.JSPrintManager.WS.status]
        );
    };

    getJSPM = () => {
        window.JSPM.JSPrintManager.license_url = `${process.env.REACT_APP_SITE_URL}/api/jspm`;
        window.JSPM.JSPrintManager.auto_reconnect = true;
        window.JSPM.JSPrintManager.start();
        // binds this class to : window.JSPM.JSPrintManager.MainApp (keep for debug)
        window.JSPM.JSPrintManager.MainApp = this;
    }

    startPrinterOrRejectPromise = (resolve, reject) => {
        //WebSocket settings
        window.JSPM.JSPrintManager.MainApp = this;

        // status change
        window.JSPM.JSPrintManager.WS.onStatusChanged = (() => {
            // update status first
            this.jspmWsUpdateStatus();

            // then get the printers list - if JSPM is running
            if (this.jspmWSStatus()) {
                console.log('boca window.JSPM.JSPrintManager.getPrintersInfo()', window.JSPM.JSPrintManager.getPrintersInfo())
                window.JSPM.JSPrintManager.getPrintersInfo().then(((printersList) => {
                    console.log('boca printersList', printersList);
                    resolve(printersList);
                }));
            } else {
                //reject(false);
            }
        });

        // Status event : onOpen
        window.JSPM.JSPrintManager.WS.onOpen = (() => {
            this.jspmWsUpdateStatus();
            window.JSPM.JSPrintManager.getPrintersInfo().then(((printersList) => {
                //let bocaPrinters = printersList.filter((printer) => printer.name.toLowerCase().includes('boca'));
                resolve(printersList);
            }));
        });

        // Status event : onClose
        window.JSPM.JSPrintManager.WS.onClose = (() => {
            this.jspmWsUpdateStatus();
        });
    };

    //Check JSPM WebSocket status
    jspmWSStatus = () => {
        if (window.JSPM.JSPrintManager.websocket_status == window.JSPM.WSStatus.Open) {
            console.log('JSPM is running');
            return true;
        }
        else if (window.JSPM.JSPrintManager.websocket_status == window.JSPM.WSStatus.Closed) {
            console.log('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
            return false;
        }
        else if (window.JSPM.JSPrintManager.websocket_status == window.JSPM.WSStatus.BlackListed) {
            console.log('JSPM has blacklisted this website!');
            return false;
        }
    };

    //Do printing...
    printFGL = (printer, labelType, labels, client, customer) => {
        if (this.jspmWSStatus()) {
            let cpj = new window.JSPM.ClientPrintJob();
            cpj.clientPrinter = new window.JSPM.InstalledPrinter(printer);
            let allLabelsFGL = '';
            for (let i = 0; i < labels.length; i++) {
                let label = labels[i];
                let labelFGL = '';

                console.log("label", label);
                console.log("cleitn", client);
                console.log("customer", customer);

                switch (labelType) {
                    case 'ticket':
                        labelFGL = generateFGLTicket(label, client, customer);
                        break;
                    case 'flexpass':
                        labelFGL = generateFGLFlexpass(label, client, customer);
                        break;
                    case 'coupon':
                        labelFGL = generateFGLCoupon(label);
                        break;
                    default:
                        labelFGL = generateFGLTicket(label, client, customer);
                }
                allLabelsFGL += labelFGL;
                let myTxtFile = new window.JSPM.PrintFileTXT(labelFGL, `myFileToPrint-${i}.txt`, 1);
                myTxtFile.fontSize = parseFloat(8);
                cpj.files.push(myTxtFile);
            }

            cpj.printerCommands = allLabelsFGL;
            setTimeout(() => {
                cpj.sendToClient();
            }, 4000);
        }
    };

    insertScriptTag = (url, callback) => {
        let aScript = document.createElement('script');
        aScript.type = 'text/javascript';
        aScript.src = url;
        document.head.appendChild(aScript);
        aScript.onload = function() {
            console.log("Script loaded:", url);
            if(callback) callback();
        };
    };
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = Boca;
} else {
    window.Boca = Boca;
}



// WEBPACK FOOTER //
// ./src/lib/labels/boca/index.js